import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";
import { btn, input, label } from "../lib/ui";
import { useI18n } from "../i18n";
import { AuthShell } from "./AuthShell";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("pub.reset.success"));
      navigate("/login");
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  if (!token)
    return (
      <AuthShell title={t("pub.reset.invalidTitle")} subtitle={t("pub.reset.invalidSubtitle")}
        footer={<Link to="/forgot-password" className="font-medium text-[#075E62] hover:text-[#0299A0]">{t("pub.reset.invalidFooter")}</Link>}>
        <p className="text-sm text-[#5F8588]">{t("pub.reset.invalidBody")}</p>
      </AuthShell>
    );

  return (
    <AuthShell title={t("pub.reset.title")} subtitle={t("pub.reset.subtitle")}
      footer={<Link to="/login" className="font-medium text-[#075E62] hover:text-[#0299A0]">{t("pub.reset.footerLink")}</Link>}>
      <form onSubmit={submit} className="flex flex-col gap-4">
        <div>
          <label className={label}>{t("pub.reset.password")}</label>
          <input data-testid="reset-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className={input} placeholder="••••••••" />
        </div>
        {err && <p data-testid="reset-error" className="text-sm text-[#A85751]">{err}</p>}
        <button type="submit" data-testid="reset-submit" disabled={busy} className={btn.accent + " w-full"}>{busy ? t("pub.reset.submitting") : t("pub.reset.submit")}</button>
      </form>
    </AuthShell>
  );
}
